import React, { useState, useEffect } from 'react';
import { Select, MenuItem, FormControl, InputLabel, CircularProgress, Box } from '@mui/material';
import clientService from '../services/clientService';

interface ClientSelectorProps {
  selectedClient: string | null;
  onClientChange: (clientName: string | null) => void;
}

const ClientSelector: React.FC<ClientSelectorProps> = ({ selectedClient, onClientChange }) => {
  const [clients, setClients] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchClients = async () => {
      try {
        setLoading(true);
        const response = await clientService.getClients();
        setClients(response.data);
      } catch (err) {
        console.error('Error fetching clients:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchClients();
  }, []);

  return (
    <FormControl fullWidth sx={{ mb: 2, maxWidth: 300 }}>
      <InputLabel>Seleccione un Cliente</InputLabel>
      <Select
        value={selectedClient || ''}
        onChange={(e) => onClientChange(e.target.value as string)}
        label="Seleccione un Cliente"
        disabled={loading}
      >
        <MenuItem value="">
          <em>Ninguno</em>
        </MenuItem>
        {loading ? (
          <Box display="flex" justifyContent="center" sx={{ p: 1 }}>
            <CircularProgress size={24} />
          </Box>
        ) : (
          clients.map((client) => (
            <MenuItem key={client} value={client}>
              {client}
            </MenuItem>
          ))
        )}
      </Select>
    </FormControl>
  );
};

export default ClientSelector;